const curationTabs = [
    "Manager",
    "Admin",
    "SeniorCurator",
    "Associate",
    "SupportAssociate",
    "Curator"
];

const offlineEventAccessLevel = "offline_event";
const eventTab = ["Admin", offlineEventAccessLevel];

const premiumTab = [
    "Manager",
    "Admin",
    "Associate",
    "SupportAssociate"
];

const recheckTab = premiumTab;
const verifiedTab = premiumTab + ["SeniorCurator"];
const biosTab = premiumTab;
const storiesTab = premiumTab;
const reportsTab = premiumTab;
const moderatedTab = premiumTab;
const memberboardTab = premiumTab;
const bannedTab = premiumTab;
const baitProfilesTab = premiumTab;
const imageLabelsTab = curationTabs;

// Sharing tab should be available anywhere curators can create/share refs.
const sharingTab = curationTabs;

const imagesTab = [
    "Manager",
    "Admin",
    "SeniorCurator",
    "Associate",
    "SupportAssociate"
]

const memberTab = [
    "Manager",
    "Admin",

]

const phoneNumbersTab = [
    "Manager",
    "Admin",
    "Associate",
]

const detailedProfileViewPermission = [
    "Manager",
    "Admin",
    "Associate",
    "SupportAssociate"
];

const profileEditPermission = [
    "Manager",
    "Admin"
];

const refundPermission = [
    "Manager",
    "Admin"
];

const invoiceModalAccess = [
    "Manager",
    "Admin",
    "SupportAssociate",
    "Associate"
]

const capturePaymentPermission = [
    "Manager",
    "Admin",
    "SupportAssociate",
    "Associate"
];

const gPlayAndSubTransferPermission = [
    "Manager",
    "Admin"
];

export {
    premiumTab,
    recheckTab,
    verifiedTab,
    biosTab,
    storiesTab,
    reportsTab,
    moderatedTab,
    memberboardTab,
    bannedTab,
    imagesTab,
    memberTab,
    detailedProfileViewPermission,
    profileEditPermission,
    refundPermission,
    invoiceModalAccess,
    capturePaymentPermission,
    gPlayAndSubTransferPermission,
    curationTabs,
    baitProfilesTab,
    phoneNumbersTab,
    imageLabelsTab,
    sharingTab,
    eventTab,
    offlineEventAccessLevel
}
